import React from "react";
import PropTypes from "prop-types";

//
import Moment from "react-moment";
import { useTable, useSortBy } from "react-table";
import ScrollBar from "react-perfect-scrollbar";
import { Dropdown } from "react-bootstrap";

//
import ReactTable from "../general/ReactTable";
import ImageBox from "../general/ImageBox";

//
import { iconImage } from "../../redux/features/coins/actions";

function DesktopTransactionList({
  symbol,
  items,
  delete_transaction,
  showEditTransactions,
}) {
  // begim::table
  const data = items;

  const columns = React.useMemo(
    () => [
      {
        Header: "type",
        accessor: "side", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;
          let date = cellProps.row.original.date;

          return (
            <div className="d-flex align-items-center">
              {/* <ImageBox src={iconImage(symbol)} alt={symbol} /> */}

              <div>
                <small className="fw-bolder text-black">
                  {value.toUpperCase()}
                </small>
                <small className="date">
                  <span className="fw-bolder">
                    <Moment utc format="MMM DD, YYYY, ">{date}</Moment>
                  </span>
                  <span>
                    <Moment utc format="hh:mm">{date}</Moment>
                  </span>
                </small>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Price ($)",
        accessor: "price", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          let split = value.split(".");

          return (
            <div className="d-flex align-items-center">
              <small className="text-black fw-bolder">${split[0]}</small>
              {split[1] && <small>.{split[1]}</small>}
            </div>
          );
        },
      },
      {
        Header: "Price (₿)",
        accessor: "btc_price", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          let split = value.split(".");

          return (
            <div className="d-flex align-items-center">
              <small className="text-black fw-bolder">${split[0]}</small>
              {split[1] && <small>.{split[1]}</small>}
            </div>
          );
        },
      },
      {
        Header: "quantity",
        accessor: "quantity", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return <small className="fw-bolder text-black">{value}</small>;
        },
      },

      {
        Header: "",
        accessor: "id",
        Cell: (cellProps) => {
          let id = cellProps.value;
          let content = cellProps.row.original;

          return (
            <Dropdown align="end" className="edit-dropdown">
              <Dropdown.Toggle className="no-border">
                <i className="las la-ellipsis-v"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ScrollBar>
                  <Dropdown.Item onClick={() => delete_transaction(id)}>
                    <small className="text-danger d-flex align-items-center fw-bolder">
                      <i className="las la-trash text-danger"></i>
                      Delete
                    </small>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => showEditTransactions(content)}>
                    <small className="text-black d-flex align-items-center fw-bolder">
                      <i className="las la-edit"></i>
                      Edit
                    </small>
                  </Dropdown.Item>
                </ScrollBar>
              </Dropdown.Menu>
            </Dropdown>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);
  // end::table

  return (
    <ReactTable
      rows={rows}
      prepareRow={prepareRow}
      headerGroups={headerGroups}
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
    />
  );
}

DesktopTransactionList.propTypes = {
  symbol: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  delete_transaction: PropTypes.func.isRequired,
  showEditTransactions: PropTypes.func.isRequired,
};

export default DesktopTransactionList;
